import { colors } from "../../../../data/colors";
import {
  occasionalCustomerField,
  occasionalResField,
} from "../../../../data/main";
import { stdObject } from "../../../../data/types/stdObject";
import { sendData } from "../../../../services/sendData";

const selectCustomer = async (
  newType: string,
  value: string,
  params: stdObject,
) => {
  const type = "CLI";
  const {
    updateDocData,
    setWindowValues,
    setModalData2,
    closeMsg,
    logoutAction,
  } = params;
  const payloadCustomer = {
    type,
    code: value,
    searchList: { [`COD${type}`]: { value, mode: 0 } },
    limit: 1,
  };
  // console.log("payloadCustomer", payloadCustomer);

  const responseCustomer = await sendData({
    endPoint: "callPersonsList",
    payload: payloadCustomer,
    logoutAction,
  });
  // console.log("responseCustomer", responseCustomer);
  if (responseCustomer.success && responseCustomer.list.length === 1) {
    updateDocData(responseCustomer.list[0], "", {
      target: newType,
      goMenu: type,
    });
    closeMsg();
    closeMsg(2);
    setWindowValues({});
    setModalData2({});
  }
};

export const checkOccasionalCustomer = async (params: stdObject) => {
  const {
    t,
    docData,
    windowValues,
    updateDocData,
    setMsg2,
    setDocValues,
    setWindowValues,
    setModalData2,
    closeMsg,
    logoutAction,
  } = params;
  let tempData = windowValues.occasionalData.map((e: string) => e.trim());
  let isOk = false;
  if (tempData[0] !== "") {
    try {
      setMsg2("loading");
      const payloadOccasional = {
        type: "CLI",
        code: tempData[0],
      };
      // console.log("payloadOccasional", payloadOccasional);

      const responseOccasional = await sendData({
        endPoint: "checkCustomerExists",
        payload: payloadOccasional,
        logoutAction,
      });

      // console.log("responseOccasional", responseOccasional);

      if (responseOccasional.success && responseOccasional.status) {
        if (responseOccasional.exists) {
          setMsg2("custom2");
          setModalData2({
            title: t("p.customerAlreadyExists", { customer: t("p.customer") }),
            label: responseOccasional.name,
            buttons: [
              {
                label: t("p.select"),
                onClick: () => {
                  selectCustomer(windowValues.occCode, tempData[0], {
                    updateDocData,
                    setWindowValues,
                    setModalData2,
                    closeMsg,
                    logoutAction,
                  });
                },
                color: colors.green,
              },
              {
                label: t("p.cancel"),
                onClick: () => {
                  closeMsg(2);
                  setModalData2({});
                },
                color: colors.darkGrey,
              },
            ],
          });
        } else {
          isOk = true;
          closeMsg(2);
          setModalData2({});
        }
      } else {
        setMsg2("error");
      }
    } catch (error) {
      setMsg2("error");
    }
  } else {
    isOk = true;
  }
  if (isOk) {
    let tempDocValues = windowValues.isDoc ? docData : {};
    if (windowValues.isDoc) {
      (windowValues.occCode === "RES"
        ? occasionalResField
        : occasionalCustomerField
      ).forEach((e: string, index: number) => {
        if (`${e}${tempDocValues.type}` in tempDocValues.data) {
          tempDocValues.data[`${e}${tempDocValues.type}`].value =
            tempData[index];
          if (["CLI", "RES"].includes(e)) {
            tempDocValues.data[`${e}${tempDocValues.type}`].name =
              tempData[index + 1];
          }
        }
      });
      setDocValues({ ...tempDocValues });
    } else {
      (windowValues.occCode === "RES"
        ? occasionalResField
        : occasionalCustomerField
      ).forEach((e: string, index: number) => {
        if (tempData[index].trim().length > 0)
          tempDocValues[e] = tempData[index].trim();
      });
      setWindowValues({
        ...windowValues,
        service: { ...windowValues.service, ...tempDocValues },
      });
    }
    closeMsg(windowValues.level);
  }
};

export const cleanDocPerson = ({
  code,
  docValues,
  setDocValues,
}: stdObject) => {
  let tempDocValues = docValues;
  (code === "RES" ? occasionalResField : occasionalCustomerField).forEach(
    (e: string) => {
      if (`${e}${tempDocValues.type}` in tempDocValues.data) {
        tempDocValues.data[`${e}${tempDocValues.type}`].value = "";
        if (["CLI", "RES"].includes(e)) {
          tempDocValues.data[`${e}${tempDocValues.type}`].name = "";
        }
      }
    },
  );
  setDocValues({ ...tempDocValues });
};

export const openCasualPerson = (params: stdObject) => {
  const {
    t,
    type,
    level = 1,
    docData,
    windowValues,
    isDoc,
    setMsg,
    setMsg2,
    setWindowValues,
  } = params;
  if (level === 2) {
    setMsg2("occasionalModal");
  } else {
    setMsg("occasionalModal");
  }
  const previousData = isDoc ? {} : windowValues;
  setWindowValues({
    ...previousData,
    level,
    isDoc,
    title: type === "RES" ? t(`d.RES`) : t(`p.occasionalCustomer`),
    occCode: type,
    occasionalData:
      type === "RES"
        ? occasionalResField.map(
            (e: string) => docData.data[`${e}${docData.type}`]?.value ?? "",
          )
        : occasionalCustomerField.map(
            (e: string) => docData.data[`${e}${docData.type}`]?.value ?? "",
          ),
  });
};
